import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
	RichText,
} from "@wordpress/block-editor";
import { PanelBody, ToggleControl } from "@wordpress/components";
import { useEffect } from "react";
import apiFetch from "@wordpress/api-fetch";

const Edit = (props) => {
	const { attributes, setAttributes } = props;
	const { techniques, description, withAttributes } = attributes;

	const updateTechnique = (index, newTechnique) => {
		const updatedTechniques = [...techniques];
		updatedTechniques[index] = newTechnique;
		setAttributes({ techniques: updatedTechniques });
	};

	// Fetch para obtener datos de la taxonomía solo la primera vez
	useEffect(() => {
		// Reemplaza 'rinoplastia' con el slug de tu taxonomía o el endpoint correcto
		apiFetch({ path: "/wp/v2/tipo_procedimiento?slug=rinoplastia-es" })
			.then((data) => {
				if (data && data.length > 0) {
					const taxData = data[0]; // Obtén el primer resultado (o ajusta según el caso)
					const defaultDescription = taxData.description || description;

					// Establece los atributos con los valores predeterminados de la taxonomía
					setAttributes({ description: defaultDescription });
				}
			})
			.catch((error) => {
				console.error("Error al obtener datos de la taxonomía:", error);
			});
	}, []); // Ejecuta solo una vez al montar el componente

	return (
		<>
			<InspectorControls>
				<PanelBody title="Opciones de Técnicas">
					<ToggleControl
						label="Mostrar Técnicas"
						checked={withAttributes}
						onChange={(value) => setAttributes({ withAttributes: value })}
					/>
				</PanelBody>
			</InspectorControls>
			<div {...useBlockProps({ className: "cg-blocks-wrapper-class" })}>
				{/* Mobile Section */}
				<div className="">
					<RichText
						tagName="p"
						className="mb-4"
						value={description}
						onChange={(ndescription) =>
							setAttributes({ description: ndescription })
						}
					/>
					{/* Renderizado condicional de técnicas */}
					{withAttributes ? (
						<div className="techniques-section">
							{techniques.map((technique, index) => (
								<div key={index} className="technique-item">
									<RichText
										tagName="h6"
										className="mb-2 text-2xl text-cgBlue font-Sans"
										value={technique.title}
										onChange={(title) =>
											updateTechnique(index, { ...technique, title })
										}
									/>
									<RichText
										tagName="p"
										value={technique.description}
										onChange={(description) =>
											updateTechnique(index, { ...technique, description })
										}
									/>
								</div>
							))}
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

export default Edit;
